function tab() {
    $('#caseNav a').click(function(e) {
        e.preventDefault();
        $(this).tab('show');
    })

    $('#newsNav a').click(function(e) {
        e.preventDefault();
        $(this).tab('show');
    })
}

module.exports = tab;


// WEBPACK FOOTER //
// ./js/page/index.js